import { useMemo } from "react";

import { ViewerArtifacts } from "../../../data/queries/viewer";
import { ArtifactData } from "./useLensTest";

const useArtifactDataTransform = (artifactData: ViewerArtifacts | null): ArtifactData | null => {
  const transformedData = useMemo((): ArtifactData | null => {
    if (!artifactData) {
      return null;
    }

    return {
      transcript: {
        content: {
          transcription: artifactData.transcript?.content?.transcription
        }
      },
      callTranscriptionRecord: {
        content: artifactData.callTranscriptionRecord?.content
      }
    };
  }, [artifactData]);

  return transformedData;
};

export { useArtifactDataTransform };
